import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../../environments/environment';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
var MachineListHttpService = /** @class */ (function () {
    function MachineListHttpService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    MachineListHttpService.prototype.getAllMachines = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_all_machines';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                console.log(response);
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    MachineListHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MachineListHttpService_Factory() { return new MachineListHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: MachineListHttpService, providedIn: "root" });
    return MachineListHttpService;
}());
export { MachineListHttpService };
